import { api, type ApiType } from 'lib/api';
import { stringParse } from 'utils';

export const apiBrands: ApiType = {
  get: {
    search: ({ query, vars }) =>
      api.get(stringParse('/api/brands?search={0}&status=true', vars), query),
    list: ({ vars }) => api.get(stringParse('/api/brands?status=true', vars)),
  },
  put: {},
  post: {},
  delete: {},
};
